<div class="contenedor">
  <div class="filters-container" style="margin-bottom: 100px !important">
    <ion-header >
      <ion-toolbar color="light" >
        <div class="header-content" [ngStyle]="{'justify-content': widthScreen > 1200 ?  'space-between' : 'flex-end'}">
          <ion-icon
            [name]="fullScreen ? 'contract' : 'expand'"
            (click)="setFullScreen()"
            *ngIf="widthScreen > 1200"
            title="Full screen"
          ></ion-icon
          ><ion-icon name="close" (click)="closeMenu()" ></ion-icon>
        </div>
        <ion-accordion-group value="first" #accordionGroup>
          <ion-accordion value="first">
            <div slot="content" class="content-item-accordion">
              <ion-grid>
                <ion-row>
                  <ion-col
                    [size]="!fullScreen ? 12 : 5"
                    style="padding-right: 20px"
                    [ngClass]="{
                      'padding-right': fullScreen,
                      'mb-5': !fullScreen
                    }"
                  >
                    <app-range-slider-date
                      [minValue]="minValue"
                      [colorIcon]="'#173d51'"
                      [popoverActive]="false"
                      [yearsBack]="5"
                      (maxDateEvent)="setRangeDate($event)"
                      (minDateEvent)="setRangeDate($event, 'start')"
                    ></app-range-slider-date>
                  </ion-col>

                  <!-- <ion-col [size]="!fullScreen ? 3 : 1">
                    <ion-select
                      class="select-filters"
                      [ngClass]="{ 'mt-3': fullScreen }"
                      [multiple]="false"
                      label-placement="stacked"
                      label="Promedio por"
                      fill="outline"
                      interface="popover"
                      name="temporalidad"
                      [(ngModel)]="temporalidadSelected"
                    >
                      <ion-select-option
                        [value]="item.value"
                        *ngFor="let item of temporalidadList"
                        >{{ item.label }}</ion-select-option
                      >
                    </ion-select>
                  </ion-col> -->

                  <ion-col [size]="!fullScreen ? 3 : 2">
                    <div
                      
                      class="custom-select"
                      [ngClass]="{ 'mt-3': fullScreen ,'invalid-select': touchDmu && dmuIds.length <= 0}"
                    >
                      <div class="select-label" (click)="openSelectPopover()">
                        {{
                          dmuIds.length >= 1
                            ? dmuIds.toString()
                            : "Dmu ( Pozos )"
                        }}
                      </div>
                      <ion-icon style="flex: 10" name="close" *ngIf=" dmuIds.length >= 1" (click)="dmuIds = []"></ion-icon>
                      <ion-icon style="flex: 10" name="caret-down" (click)="openSelectPopover()"></ion-icon>
                    </div>
                    <!-- <ion-select [multiple]="wellList.length <= 0 ? false : true" label="DMU(Pozos)"
                  label-placement="floating" fill="outline" interface="popover" name="dmuIds" [(ngModel)]="dmuIds">
                  <ion-select-option [value]="item.name" *ngFor="let item of wellList">{{ item.name
                    }}</ion-select-option>
                  <ion-select-option value="" *ngIf="wellList.length <= 0" disabled>No hay series
                    disponibles</ion-select-option>
                </ion-select> -->
                  </ion-col>
                  <ion-col [size]="!fullScreen ? 3 : 2">
                    <div
                      class="custom-select"
                      [ngClass]="{ 'mt-3': fullScreen, 'invalid-select': touchSerie && labelsSelected.length <= 0 }"
                    >
                      <div class="select-label" (click)="openSelectSeries();">
                        {{
                          labelsSelected.length >= 1
                            ? labelsSelected.toString()
                            : "Series"
                        }}
                      </div>
                      <ion-icon style="flex: 10" name="close" *ngIf=" labelsSelected.length >= 1" (click)="labelsSelected = []"></ion-icon>
                      <ion-icon style="flex: 10" name="caret-down" (click)="openSelectSeries();"></ion-icon>
                    </div>
                  </ion-col>
                  <!-- <ion-col [size]="!fullScreen ? 3 : 2">
                    <ion-select
                      [multiple]="labelListGraph.length <= 0 ? false : true"
                      class="select-filters"
                      label-placement="stacked"
                      [ngClass]="{ 'mt-3': fullScreen }"
                      label="Series"
                      fill="outline"
                      interface="popover"
                      name="labelIds"
                      [(ngModel)]="labelIds"
                    >
                      <ion-select-option
                        [value]="item.id"
                        *ngFor="let item of labelListGraph"
                        >{{ item.name }}</ion-select-option
                      >
                      <ion-select-option
                        value=""
                        *ngIf="labelListGraph.length <= 0"
                        disabled
                        >No hay series disponibles</ion-select-option
                      >
                    </ion-select>
                  </ion-col> -->

                  <ion-col [size]="!fullScreen ? 3 : 2">
                    <ion-select
                      [multiple]="false"
                      label-placement="stacked"
                      [mode]="'md'"
                      [ngClass]="{ 'mt-3': fullScreen }"
                      label="Normalización"
                      fill="outline"
                      interface="popover"
                      name="standardization"
                      class="select-filters"
                      [(ngModel)]="standardizationSelected"
                    >
                      <ion-select-option
                        [value]="item.value"
                        *ngFor="let item of standardizationList"
                        >{{ item.label }}</ion-select-option
                      >
                    </ion-select>
                  </ion-col>

                  <ion-col [size]="!fullScreen ? 3 : 2">
                    <ion-select
                      [multiple]="false"
                      [mode]="'md'"
                      label-placement="stacked"
                      [ngClass]="{ 'mt-3': fullScreen }"
                      label="Orden"
                      fill="outline"
                      interface="popover"
                      name="order"
                      class="select-filters"
                      [(ngModel)]="orderSelected"
                    >
                      <ion-select-option
                        [value]="item.value"
                        *ngFor="let item of orderList"
                        >{{ item.label }}</ion-select-option
                      >
                    </ion-select>
                  </ion-col>

                  <ion-col
                    [size]="12"
                    class="ion-text-end"
                    style="max-height: 22px"
                  >
                    <ion-button
                      color="secondary"
                      [disabled]="
                        labelIds.length <= 0 ||
                        labelListGraph.length <= 0 ||
                        dmuIds.length <= 0 ||
                        wellList.length <= 0
                      "
                      (click)="getGraphData()"
                      class="btn-search-zone"
                      ><ion-icon slot="start" name="filter"></ion-icon>APLICAR
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-toolbar>
    </ion-header>
    <div class="ion-text-center">
      <ion-button class="toggle-filters" (click)="toggleAccordion()"
        >FILTROS<ion-icon
          slot="end"
          [name]="accordionShow ? 'chevron-up-sharp' : 'chevron-down-outline'"
        ></ion-icon
      ></ion-button>
    </div>
  </div>
  <div
    class="container-test"
    #dragItem
    [ngStyle]="zoomStyles"
    id="container2"
    
  >
    <div class="content" style="cursor: grabbing" id="object2" cdkDragHandle>
      <!-- Contenido del div que se va a hacer zoom -->
      <app-chart-js
        *ngIf="data.length >= 1"
        [chartData]="data"
        [dmus]="dmuIds"
        [startDate]="startDate"
        [endDate]="endDate"
        [filterToggle]="accordionShow"
        [fullScreen]="fullScreen"
        [order]="orderSelected"
      ></app-chart-js>
    </div>
  </div>
</div>


